import { combineReducers } from 'redux';
import fundingPositions from './fundingPositions';
import fees from './fees';

export default combineReducers({
  fundingPositions,
  fees,
});
